module.exports = __webpack_public_path__ + "app/img/logoSP360.eb1ab82c.png";